export default {
    track(action, category, label, detail) {
        // console.log({
        //     'action': action,
        //     'event_category': category,
        //     'event_label': label,
        //     'event_detail': detail
        // });
        window.gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'event_detail': detail
        })
    }
}
